module.exports = __webpack_public_path__ + "d13c9f26.woff2";